export default "__VITE_ASSET__CB$Mu5yg__"